// Libraries
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import { useContext } from 'react';
import { useSelector } from 'react-redux';

// Dependencies
import TranslationsContext from 'providers/translationsProvider';
import queryString from 'utils/queryString';
import { getCustomizationProps, getLayoutStyle } from 'views/Auth/utils';

// Services
import teamService from 'services/team';

// Components
import { Col, Row } from 'antd';
import { Img } from 'components/elements';
import { P } from 'components/fontSystem';
import LoginForm from 'containers/LoginForm';
import Layout from 'views/Auth/Layout';

// Assets
import whiteLogo from 'static/images/Bridgeforbillions_white.png';

const STATUS_INVITE_ACCEPTED = 1;

const year = dayjs().year();

const Login = ({ isCustomLink }) => {
  const { format, t } = useContext(TranslationsContext);
  const { data: customization, isFetching } = useSelector(state => state.customization);

  const { memberToken, mentorToken } = queryString.parse(document.location.search);
  let handleOnAuth;
  if (memberToken || mentorToken) {
    handleOnAuth = ({ member, mentor }) =>
      teamService.updateMemberInvite({
        id: memberToken || mentorToken,
        member: member && member.id,
        mentor: mentor && mentor.id,
        status: STATUS_INVITE_ACCEPTED,
      });
  }

  const layoutStyle = getLayoutStyle(customization, isCustomLink, isFetching);

  const customizationProps = getCustomizationProps(customization, isFetching);

  return (
    <Layout style={layoutStyle}>
      <Layout.Header />
      <Layout.Content>
        <Row align="middle" justify="center" type="flex">
          <Col xs={23} sm={18} lg={14} xl={11} xxl={9}>
            <LoginForm isCustomLink={isCustomLink} {...customizationProps} onAuth={handleOnAuth} />
          </Col>
        </Row>
      </Layout.Content>
      <Layout.Footer style={{ padding: '24px' }}>
        {customization.id && (
          <Row
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <P
              style={{
                margin: '0 5px 0 0',
                fontSize: 12,
                fontStyle: 'italic',
                color: 'white',
              }}
            >
              {t('This online incubation program is powered by')}
            </P>
            <Img width={157} src={whiteLogo} />
          </Row>
        )}
        <P style={{ fontSize: 12, color: customization.id ? 'white' : 'black' }}>
          {format(t('Copyright © %(year)s. All Rights Reserved'), {
            year: String(year),
          })}
        </P>
      </Layout.Footer>
    </Layout>
  );
};

Login.propTypes = {
  isCustomLink: PropTypes.bool.isRequired,
};

export default Login;
// Dynamicly imported